<template>
  <div class="layout-wrapper">
    <!-- 顶部导航栏 -->
    <nav class="navbar navbar-expand-lg navbar-white bg-white">
      <div class="container-fluid custom-container">
        <img src="@/assets/head/logo.png" class="logo" alt="Cinque Terre" />
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav ms-auto">
            <li class="nav-item" v-for="item in menu" :key="item.name">
              <router-link class="nav-link" :to="item.path">{{ item.name }}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- 中间内容区域 -->
    <main class="main-content container-fluid mt-4">
      <router-view />
    </main>

    <!-- 页脚区域 -->
    <footer class="footer">
      <AppFooter />
    </footer>
  </div>
</template>

<script>
import AppFooter from './components/Footer.vue'

export default {
  components: {
    AppFooter
  },
  data() {
    return {
      menu: [
        { name: '首页', path: '/' },
        { name: '服务', path: '/services' },
        { name: '解决方案', path: '/solutions' },
        { name: '关于我们', path: '/about' },
        { name: '联系我们', path: '/contact' }
      ]
    }
  }
}
</script>

<style>
html, body, #app {
  height: 100%;
  margin: 0;
  font-family: Arial, sans-serif;
}

/* 设置整体垂直方向布局 */
.layout-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* 内容区域自动填充剩余高度 */
.main-content {
  flex: 1;
  /* 如果需要内部滚动可以加 overflow-y: auto; */
}

/* 页脚 */
.footer {
  background-color: #f8f8f8;
  padding: 16px 0;
  text-align: center;
}

/* 自定义 container 居中 */
.custom-container {
  width: 60%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 0;
  padding-right: 0;
  flex-wrap: nowrap;
}

/* Logo 自适应 */
.logo {
  max-width: 288px;
  height: auto;
  user-select: none;
  flex-shrink: 0;
}

/* 菜单样式 */
.navbar-nav {
  display: flex;
  align-items: center;
  margin-left: auto;
  padding-left: 0;
}

.navbar-nav .nav-item {
  margin: 0 15px;
  font-size: 22px;
}

.nav-link {
  position: relative;
  color: black;
  text-decoration: none;
  padding-bottom: 5px;
  transition: all 0.3s ease;
}

.nav-link:hover::after,
.nav-link.router-link-active::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2px;
  width: 100%;
  background-color: #1664FF;
}

/* 去除 Bootstrap 默认内边距 */
.navbar {
  padding-left: 0;
  padding-right: 0;
}

/* 响应式 */

/* Tablet 以下，平板和小屏 */
@media (max-width: 992px) {
  .custom-container {
    width: 90%;
    justify-content: space-between;
  }
  .navbar-nav .nav-item {
    margin: 0 10px;
    font-size: 18px;
  }
  .logo {
    max-width: 220px;
  }
}

/* Mobile 以下，手机屏幕 */
@media (max-width: 576px) {
  .custom-container {
    width: 95%;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  /* 汉堡按钮显示 */
  .navbar-toggler {
    display: block;
    border: none;
    background: none;
    padding: 0;
    margin-left: auto;
  }

  .navbar-toggler-icon {
    width: 25px;
    height: 2px;
    background-color: #333;
    display: block;
    position: relative;
  }
  .navbar-toggler-icon::before,
  .navbar-toggler-icon::after {
    content: "";
    width: 25px;
    height: 2px;
    background-color: #333;
    display: block;
    position: absolute;
    left: 0;
  }
  .navbar-toggler-icon::before {
    top: -7px;
  }
  .navbar-toggler-icon::after {
    top: 7px;
  }

  /* 默认隐藏菜单，展开时显示 */
  .navbar-collapse {
    width: 100%;
    display: none;
    flex-direction: column;
    margin-top: 10px;
  }
  .navbar-collapse.show {
    display: flex !important;
  }

  .navbar-nav {
    flex-direction: column;
    width: 100%;
  }

  .navbar-nav .nav-item {
    margin: 10px 0;
    font-size: 20px;
    text-align: center;
  }
}
</style>
